export class AccountPreferencesChanged {
  preferences: Array<Object>;

  constructor(data) {
    this.preferences = [];
    this._mapData(data);
  }

  _mapData(stayPreferences) {
    let userPreferences = [];
    if(!!stayPreferences && !!stayPreferences.categories){
      stayPreferences.categories.forEach((preference) => {
        preference.preferences.forEach((selection) => {
          if(!!selection.selectedValue || (selection.selectedValue === "")){
            let individualPreference = {
              key:selection.key,
              value:selection.selectedValue
            };
            userPreferences.push(individualPreference);
          }
        });
      });
    }
    this.preferences = userPreferences;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/user/stay-preferences/account-preferences-changed.model.ts